export default __webpack_public_path__ + "media/suspicious_login_attempt/date-f62e1409.png";